import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";

const AddActionToBeTaken = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("businessPartnerId");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (!result.isConfirmed) {
      Swal.fire({
        title: "Cancelled",
        text: "The action has been cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return;
    }
    setLoading(true);

    try {
      const payload = {
        action_tobe_taken_name: formData.action_tobe_taken_name,
        action_tobe_taken_desc: formData.action_tobe_taken_desc,
        status: formData.status === "Active" ? 1 : 0,
      };

      // Handle business partner ID based on user type
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      // Make the API request to create the action to be taken record
      const response = await axiosInstance.post(
        "/actiontobetaken/create",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log("Record added successfully:", response.data);

      // Success handling
      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: "Action to be taken added successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/admin/manage-lead/action-to-be-taken"); // Navigate after user clicks OK
        });
      }
    } catch (error) {
      console.error("Error adding record:", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";

      // Show error alert
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      // Reset loading state
      setLoading(false);
    }
  };

  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "action_tobe_taken_name",
      label: "Name",
      type: "text",
      placeholder: "Enter Action To Be Taken",
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "action_tobe_taken_desc",
      label: "Enter Description",
      placeholder: "Enter Action To Be Taken Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const handleNavigate = () => {
    navigate("/admin/manage-lead/action-to-be-taken");
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={handleNavigate}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add Action To Be Taken</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Action To Be Taken Details
            </span>
            <DynamicForm
              formConfig={CustomerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>

          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AddActionToBeTaken;
